import { createNewChat } from "@Api/createNewChat";
import { useUserContext } from "@Hooks/contexts/useUserContext";
import { IconButton, PlusIcon, SegmentedControl, TopBar } from "@UI";
import React from "react";
import { useTranslation } from "react-i18next";
import { AccountMenu } from "./AccountMenu";
export function AppBar({ activeTab, onTabChange }) {
    const { t } = useTranslation();
    const token = useUserContext((s)=>s?.user?.meta?.access_token.token);
    const tabs = [
        {
            value: "chat",
            label: t("chat.assistant")
        },
        {
            value: "promptlib",
            label: t("prompts.multiple")
        },
        {
            value: "workflows",
            label: t("workflows.multiple")
        }
    ];
    return /*#__PURE__*/ React.createElement(TopBar, {
        end: /*#__PURE__*/ React.createElement(React.Fragment, null, activeTab === "chat" && /*#__PURE__*/ React.createElement(IconButton, {
            size: "sm",
            "aria-label": t("shell.newChat"),
            onClick: ()=>token && createNewChat(),
            disabled: !token
        }, /*#__PURE__*/ React.createElement(PlusIcon, null)), /*#__PURE__*/ React.createElement(AccountMenu, null))
    }, /*#__PURE__*/ React.createElement(SegmentedControl, {
        "aria-label": t("shell.nav"),
        fitContent: true,
        options: tabs,
        value: activeTab,
        onChange: onTabChange,
        getTabId: (tab)=>`tab-${tab}`,
        getPanelId: (tab)=>tab === "chat" || tab === activeTab ? `panel-${tab}` : undefined
    }));
}
